// Manages all the columns and formatters for the disposition grid

const helpers={

    // returns an array of columns for the dispoition grid
    getDispoDefaultColumns:function(){
        let columnDefs= [
            { headerName: '#', field: 'itemNumber', checkboxSelection:true,width:120, headerCheckboxSelection: true },
            { headerName: 'Item', field: 'ShortDescription', sortable: true,width:350,  filter: true, enableRowGroup: true, cellStyle:{fontWeight:'bold' }},
            { headerName: 'Found Near', field: 'locationName', sortable: true,  filter: true,enableRowGroup: true },
            { headerName: 'Status', field: 'itemStateDesc', sortable: true,  filter: true,enableRowGroup: true },
            { headerName: 'Age', field: 'age', sortable: true,  filter: 'agNumberColumnFilter', enableRowGroup: true },
            { headerName: 'Release Date', field: 'releaseDate',sortable: true,  filter: 'agDateColumnFilter', valueFormatter:helpers.formatDateTime},
            { headerName: 'Desc.', field: 'LongDescription',sortable: true,  filter: true, },
            { headerName: 'Found By', field: 'foundByName', sortable: true,  filter: true,enableRowGroup: true},
            { headerName: 'Storage location', field: 'storageLocation', sortable: true,  filter: true,enableRowGroup: true},
            { headerName: 'Category', field: 'category',sortable: true,  filter: true},
            { headerName: 'Keywords', field: 'keywords',sortable: true,  filter: true},
            { headerName: 'Found On', field: 'foundDate',sortable: true, filter: 'agDateColumnFilter',  valueFormatter:helpers.formatDateTime},
            { headerName: 'Found By ID', field: 'foundByEmployeeId',sortable: true,  filter: true},
            { headerName: 'Returned To Staff', field: 'isReturnedToStaff',sortable: true,  filter: true, valueFormatter:helpers.formatBoolean},
            { headerName: 'Disposition Dt.', field: 'donateDisposeDate',sortable: true, filter: 'agDateColumnFilter',  valueFormatter:helpers.formatDateTime},
            { headerName: 'Disposition Note', field: 'donateDisposeNote',sortable: true,  filter: true},
        ]
        return columnDefs;
    },
    getDefaultProps:function(){
        let defaultColDef= {
            flex: 0,
          
            // allow every column to be aggregated
            enableValue: true,
            // allow every column to be grouped
            enableRowGroup: true,
            // allow every column to be pivoted
            //enablePivot: true,
            sortable: true,
            //filter: true,
            resizable: true
          }
          return defaultColDef;

    },
    formatDateTime: function(params){
        try {
            if (params.value){
                var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                let cellDate = new Date(params.value);
                return cellDate.toLocaleDateString([],options) +  ' ' + cellDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
            }else{
                return  '';
            }
        }catch(e){
            return  '';

        }
      },
      formatBoolean:function(params){
        return (params.value) ? "YES" : "NO"
      }

}

export default helpers